import styled from "@emotion/styled"
import { PIcon, PInlineNotification, PText } from "@porsche-design-system/components-react"
import { spacingStaticXs } from "@porsche-design-system/components-react/emotion"
import type { VinSearchResultView } from "@slfinrtl/ui-bff-routes"
import { defineMessages, FormattedMessage, useIntl } from "react-intl"

const messages = defineMessages({
	draftOtherStockDescription: {
		defaultMessage:
			"The vehicle is already in the creation process of another stock. If you want to add it to your stock, it will be removed from the other stock.",
		id: "inventorylist.addVehicle.searchResult.draftOtherStockDescription",
	},
	draftOtherStockTitle: {
		defaultMessage: "Vehicle already in creation",
		id: "inventorylist.addVehicle.searchResult.draftOtherStockTitle",
	},
	failedMissingWarranty: {
		defaultMessage:
			"Adding this vehicle is not possible because it is a new car without new car warranty and needs to be managed within PVMS.",
		id: "inventorylist.addVehicle.searchResult.failed.missingWarranty",
	},
	failedOtherStock: {
		defaultMessage:
			"Adding this vehicle is not possible. The vehicle is currently in stock of {displayName} with the vehicle number {inventoryNumber}.",
		id: "inventorylist.addVehicle.searchResult.failed.otherStock",
	},
	failedOwnStock: {
		defaultMessage: "Vehicle is already in your stock",
		id: "inventorylist.addVehicle.searchResult.failed.ownStock",
	},
	successful: {
		defaultMessage: "Entered VIN matches the following vehicle",
		id: "inventorylist.addVehicle.searchResult.success",
	},
})

type VinSearchResultMessageProps = VinSearchResultView

export const VinSearchResultMessage = ({
	inventoryNumber,
	otherOwningDealership,
	state,
}: VinSearchResultMessageProps) => {
	const { formatMessage } = useIntl()
	return ["ALREADY_EXISTS", "OTHER_OWNING_DEALERSHIP", "PVMS_MANAGED"].includes(state) ? (
		<ResultMessage>
			<PIcon color="error" name="exclamation" />
			<PText color="error">
				{state === "OTHER_OWNING_DEALERSHIP" ? (
					<FormattedMessage
						{...messages.failedOtherStock}
						values={{
							displayName: otherOwningDealership?.displayName,
							inventoryNumber,
						}}
					/>
				) : state === "PVMS_MANAGED" ? (
					<FormattedMessage {...messages.failedMissingWarranty} />
				) : (
					<FormattedMessage {...messages.failedOwnStock} />
				)}
			</PText>
		</ResultMessage>
	) : state === "DRAFT_OTHER_OWNING_DEALERSHIP" ? (
		<PInlineNotification
			state="warning"
			dismissButton={false}
			heading={formatMessage(messages.draftOtherStockTitle)}
			description={formatMessage(messages.draftOtherStockDescription)}
		/>
	) : (
		<ResultMessage>
			<PIcon color="success" name="check" />
			<PText color="success">
				<FormattedMessage {...messages.successful} />
			</PText>
		</ResultMessage>
	)
}

const ResultMessage = styled.div`
	display: flex;
	align-items: center;
	gap: ${spacingStaticXs}
`
